const dict = {
  uk: {
    cancel: 'Скасувати',
    save: 'Зберегти',
    delete: 'Видалити',
    close: 'Закрити',
    loading: 'Завантаження...',
    back: 'Назад',
    backHome: 'На головну',
    submit: 'Подати',
    submitting: 'Надсилаємо…',
    edit: 'Редагувати',
    create: 'Створити',
    confirm: 'Підтвердити',
    yes: 'Так',
    no: 'Ні',
    optional: 'опційно',
    from: 'З',
    to: 'До',
    date: 'Дата',
    reason: 'Причина',
    type: 'Тип',
    lightTheme: 'Світла тема',
    darkTheme: 'Темна тема',
    logout: 'Вихід',
    add: 'Додати',
    remove: 'Прибрати',
    saving: 'Збереження...',
    saved: 'Збережено',
    error: 'Помилка',
    success: 'Успіх',
    errorTryAgain: 'Сталася помилка. Спробуйте ще раз.',
    retry: 'Спробувати ще раз',
    yesConfirm: 'Так, підтвердити',
    noCancel: 'Ні, скасувати',
    ok: 'OK',
    apply: 'Застосувати',
    next: 'Далі',
    prev: 'Назад',
    finish: 'Завершити',
    open: 'Відкрити',
    hide: 'Сховати',
    show: 'Показати',
    search: 'Пошук',
    all: 'Всі',
    none: 'Нічого',
    today: 'Сьогодні',
    tomorrow: 'Завтра',
    yesterday: 'Вчора',
    minutes: 'хв',
    hours: 'год',
    days: 'днів',
    day: 'день',
    week: 'тиждень',
    month: 'місяць',
    year: 'рік',
    time: 'Час',
    student: 'Учень',
    teacher: 'Вчитель',
    admin: 'Адмін',
    name: 'Ім\'я',
    title: 'Назва',
    description: 'Опис',
    notes: 'Нотатки',
    status: 'Статус',
    actions: 'Дії',
    view: 'Переглянути',
    download: 'Завантажити',
    upload: 'Завантажити',
    copy: 'Скопіювати',
    copied: 'Скопійовано',
    send: 'Надіслати',
    sending: 'Надсилаємо...',
    sent: 'Надіслано',
    yes_short: 'Так',
    no_short: 'Ні',
    notFoundTitle: 'Сторінку не знайдено',
    notFoundDescription: 'Можливо, посилання застаріло або ви помилилися в адресі. Перевірте URL або поверніться на головну.',
    notFoundBack: 'Назад',
    notFoundHome: 'На головну',
    notFoundContactPrefix: 'Щось не працює?',
    notFoundContactLink: 'Напишіть у підтримку',
    errorBoundaryTitle: 'Щось пішло не так',
    errorBoundaryMessage: 'Виникла несподівана помилка. Спробуйте перезавантажити сторінку.',
    errorBoundaryDetails: 'Деталі помилки',
    errorBoundaryReload: 'Перезавантажити',
    overallLevel: 'Загальний рівень',
    skillListening: 'Аудіювання',
    skillSpeaking: 'Говоріння',
    skillReading: 'Читання',
    skillWriting: 'Письмо',
    update: 'Оновити',
    datePicker: {
      today: 'Сьогодні',
      clear: 'Очистити',
      time: 'Час',
      selectDate: 'Оберіть дату',
      prevMonth: 'Попередній місяць',
      nextMonth: 'Наступний місяць',
    },
  },
  en: {
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    close: 'Close',
    loading: 'Loading...',
    back: 'Back',
    backHome: 'Back to home',
    submit: 'Submit',
    submitting: 'Submitting…',
    edit: 'Edit',
    create: 'Create',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    optional: 'optional',
    from: 'From',
    to: 'To',
    date: 'Date',
    reason: 'Reason',
    type: 'Type',
    lightTheme: 'Light theme',
    darkTheme: 'Dark theme',
    logout: 'Log out',
    add: 'Add',
    remove: 'Remove',
    saving: 'Saving...',
    saved: 'Saved',
    error: 'Error',
    success: 'Success',
    errorTryAgain: 'An error occurred. Please try again.',
    retry: 'Try again',
    yesConfirm: 'Yes, confirm',
    noCancel: 'No, cancel',
    ok: 'OK',
    apply: 'Apply',
    next: 'Next',
    prev: 'Back',
    finish: 'Finish',
    open: 'Open',
    hide: 'Hide',
    show: 'Show',
    search: 'Search',
    all: 'All',
    none: 'None',
    today: 'Today',
    tomorrow: 'Tomorrow',
    yesterday: 'Yesterday',
    minutes: 'min',
    hours: 'h',
    days: 'days',
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year',
    time: 'Time',
    student: 'Student',
    teacher: 'Teacher',
    admin: 'Admin',
    name: 'Name',
    title: 'Title',
    description: 'Description',
    notes: 'Notes',
    status: 'Status',
    actions: 'Actions',
    view: 'View',
    download: 'Download',
    upload: 'Upload',
    copy: 'Copy',
    copied: 'Copied',
    send: 'Send',
    sending: 'Sending...',
    sent: 'Sent',
    yes_short: 'Yes',
    no_short: 'No',
    notFoundTitle: 'Page not found',
    notFoundDescription: 'The link may be outdated or the address may be incorrect. Check the URL or go back to the home page.',
    notFoundBack: 'Back',
    notFoundHome: 'Home',
    notFoundContactPrefix: 'Something not working?',
    notFoundContactLink: 'Contact support',
    errorBoundaryTitle: 'Something went wrong',
    errorBoundaryMessage: 'An unexpected error occurred. Please try reloading the page.',
    errorBoundaryDetails: 'Error details',
    errorBoundaryReload: 'Reload',
    overallLevel: 'Overall level',
    skillListening: 'Listening',
    skillSpeaking: 'Speaking',
    skillReading: 'Reading',
    skillWriting: 'Writing',
    update: 'Update',
    datePicker: {
      today: 'Today',
      clear: 'Clear',
      time: 'Time',
      selectDate: 'Select date',
      prevMonth: 'Previous month',
      nextMonth: 'Next month',
    },
  },
};

export default dict;
